import type { ReactNode } from 'react';
import { create } from 'zustand';

interface BreadcrumbSlotState {
  /** When non-null, the persistent AppTopBar renders this instead of its
   *  `headerLeft` prop. Lets a deep page (e.g. campaign detail) publish a
   *  breadcrumb that reflects its in-page tab/sub-section. */
  node: ReactNode | null;
  setNode: (node: ReactNode | null) => void;
}

/**
 * Breadcrumb slot for the persistent app shell.
 *
 * The top bar lives in `AppLayout` (mounted once), but the richest breadcrumb
 * state — the active campaign name, tab, and reporting sub-section — lives deep
 * inside the campaign page. Rather than thread that up through props, the page
 * publishes a ready-to-render breadcrumb node here on mount/route-change and
 * clears it on unmount; `AppTopBar` reads and renders it.
 */
export const useBreadcrumbSlot = create<BreadcrumbSlotState>((set) => ({
  node: null,
  setNode: (node) => set({ node }),
}));
